import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { registerSW } from "virtual:pwa-register";

// Enhanced service worker registration with error handling
try {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      if (confirm("New content available. Reload?")) {
        updateSW(true);
      }
    },
    onOfflineReady() {},
    onRegistered(r: ServiceWorkerRegistration) {
      if (r && r.update) {
        r.update();
      }
    },
    onRegisterError(error: Error) {
      console.error("❌ SW registration error:", error);
    },
  });
} catch (error) {
  console.error("❌ Failed to register service worker:", error);
}

// Polyfill for older browsers
if (!window.Promise) {
  window.Promise = Promise;
}

// Check for service worker support
if ("serviceWorker" in navigator) {
  // Additional service worker registration for better compatibility
  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (const registration of registrations) {
        registration.update();
      }
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
